import { formatDateTime as formatUserDateTime, parseTimestamp } from './dateTimeFormat';

export { parseTimestamp };

export const formatDateTime = (timestamp) => formatUserDateTime(timestamp);

const formatTimestamp = (timestamp) => {
  const now = new Date();
  const date = parseTimestamp(timestamp);
  if (!date || Number.isNaN(date.getTime())) {
    return '';
  }
  const seconds = Math.floor((now - date) / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return 'just now';
  } else if (minutes < 60) {
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
  } else if (hours < 24) {
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  } else if (days < 7) {
    return `${days} ${days === 1 ? 'day' : 'days'} ago`;
  } else {
    return formatUserDateTime(date);
  }
};

export default formatTimestamp;
